import { combineReducers } from 'redux';
import resourceReducer from './resource';
import loading from './loading';
import notification from './notification';
import references from './references';
import saving from './saving';
import ui from './ui';
import filter from './filter';
import recordSelected from "./recordSelected";
import { location } from './location';
import { newsImage } from './news';
import { advancedFunction } from './advancedFunction';
import { shop } from './shop';
import { e_payment } from './e_payment';

export default (resources) => {
  const resourceReducers = {};
  resources.forEach((resource) => {
    resourceReducers[resource.name] = resourceReducer(resource.name, resource.options);
  });
  return combineReducers({
    ...resourceReducers,
    loading,
    notification,
    references,
    saving,
    ui,
    filter,
    recordSelected,
    location,
    newsImage,
    advancedFunction,
    shop,
    e_payment,
  });
};



// WEBPACK FOOTER //
// ./src/reducers/index.js